export const UnfoldLessIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7998_254769)">
      <path d="M4.9375 12.3934L5.88417 13.3334L7.9975 11.22L10.1108 13.3334L11.0508 12.3934L7.9975 9.33335L4.9375 12.3934ZM11.0575 3.60669L10.1108 2.66669L7.9975 4.78002L5.88417 2.66669L4.9375 3.60669L7.9975 6.66669L11.0575 3.60669Z" />
    </g>
    <defs>
      <clipPath id="clip0_7998_254769">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
